import React, { useState } from "react";
import { BarChart, yAxisSides } from "react-gifted-charts";
import { YStack } from "tamagui";
import { tokens } from "tamagui-config";

export interface EnergyCostChartProps {
  dailyCosts: { value: number; label: string }[];
  averageCost: number;
}

export const EnergyCostChart: React.FC<EnergyCostChartProps> = ({
  dailyCosts,
  averageCost,
}) => {
  const [parentWidth, setParentWidth] = useState(0);

  const barWidth = 16;
  const initialSpacing = 10;
  const endSpacing = 10;
  const n = dailyCosts.length;
  const yAxisLabelWidth = 60;
  const chartPadding = 36;

  const chartWidth =
    parentWidth > 0 ? parentWidth - yAxisLabelWidth - chartPadding : undefined;

  const availableWidth =
    parentWidth > 0 ? parentWidth - yAxisLabelWidth - chartPadding - 10 : 0;

  const spacing =
    n > 1
      ? Math.max(
          0,
          (availableWidth - initialSpacing - endSpacing - n * barWidth) /
            (n - 1),
        )
      : 0;

  const formatYLabel = (value: string) =>
    Number(value) === 0
      ? "$0.00"
      : Number(value) < 10
        ? `$0${value}.00`
        : `$${value}.00`;

  return (
    <YStack
      width="100%"
      onLayout={({ nativeEvent }) => setParentWidth(nativeEvent.layout.width)}
    >
      <BarChart
        data={dailyCosts.map((item) => ({
          value: item.value,
          label: item.label,
        }))}
        height={115}
        width={chartWidth}
        barWidth={barWidth}
        initialSpacing={initialSpacing}
        spacing={spacing}
        endSpacing={endSpacing}
        noOfSections={2}
        roundedTop
        frontColor={tokens.color.hgPrimary}
        rulesColor={tokens.color.white6}
        rulesType="solid"
        xAxisThickness={0}
        xAxisLabelTextStyle={{
          color: tokens.color.white12,
          fontSize: 14,
        }}
        yAxisThickness={0}
        yAxisLabelWidth={60}
        yAxisSide={yAxisSides.RIGHT}
        formatYLabel={formatYLabel}
        yAxisTextStyle={{
          color: tokens.color.white12,
          fontSize: 14,
        }}
        yAxisLabelContainerStyle={{
          paddingTop: 5,
          marginLeft: 10,
        }}
        showReferenceLine1
        referenceLinesOverChartContent={false}
        referenceLine1Position={averageCost}
        referenceLine1Config={{
          color: tokens.color.hgSecondary,
          thickness: 2,
        }}
      />
    </YStack>
  );
};
